import React from 'react';
import { Pivot, PivotItem } from '@fluentui/react';
import { Color } from '../../../const/Const';
import HiredDtl from '../HiredDtl/HiredDtl';
import SalaryReports from '../SalaryReports/SalaryReports';
import ReportBasic from '../ReportBasic/ReportBasic';
import { useNavigate, useSearchParams } from 'react-router-dom';

const Home = (props) => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const onLinkClick = (pTab) => {
        navigate('/hrsuite/report?tab=' + pTab?.props?.itemKey);
    }

    return (
        <div>
            <div className='pageTitle' style={{ padding: 14, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ fontWeight: 600, fontSize: 24, color: "#3B3B3B" }}>Тайлан</div>
                <div style={{ marginTop: 4, fontWeight: 400, fontSize: 12, color: '#3B3B3B' }}>Тайлангийн дэлгэрэнгүй мэдээлэл</div>
            </div>
            <div>
                <Pivot
                    selectedKey={searchParams.get("tab") ? searchParams.get("tab") : "0"}
                    styles={{
                        linkIsSelected: {
                            '&::before': {
                                backgroundColor: Color.primary
                            }
                        },
                        root: {
                            paddingLeft: 7
                        }
                    }}
                    onLinkClick={onLinkClick}>
                    <PivotItem
                        headerText="Ажилтны үндсэн мэдээлэл"
                        itemKey='reportbasic'
                    >
                        <ReportBasic />
                    </PivotItem>
                    <PivotItem
                        headerText="Ажил эрхлэлт"
                        itemKey='reporthrempempl'
                    >
                        <HiredDtl />
                    </PivotItem>
                    <PivotItem
                        headerText="Цалин"
                        itemKey='reportsalary'
                    >
                        <SalaryReports />
                    </PivotItem>
                </Pivot>
            </div>
        </div>
    );
}

export default Home;